import { render, staticRenderFns } from "./ProcessTransload.vue?vue&type=template&id=5410ea16&scoped=true"
import script from "./ProcessTransload.vue?vue&type=script&lang=js"
export * from "./ProcessTransload.vue?vue&type=script&lang=js"
import style0 from "./ProcessTransload.vue?vue&type=style&index=0&id=5410ea16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5410ea16",
  null
  
)

export default component.exports